import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, TextField } from '@mui/material';
import type { KeyboardEvent } from 'react';

interface AVNameInlineEditProps {
  isEditing: boolean;
  editedName: string;
  validationError?: string;
  isEditable: boolean;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
  children: React.ReactNode;
}

export const AVNameInlineEdit = ({
  isEditing,
  editedName,
  validationError,
  isEditable,
  onStartEdit,
  onSave,
  onCancel,
  onChange,
  children,
}: AVNameInlineEditProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !validationError) onSave();
    if (e.key === 'Escape') onCancel();
  };

  if (isEditing) {
    return (
      <Box data-testid="av-name-inline-edit" display="flex" alignItems="flex-start" gap={1}>
        <TextField
          data-testid="av-name-input"
          value={editedName}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          error={!!validationError}
          helperText={validationError}
          size="small"
          autoFocus
          sx={{ minWidth: 300 }}
        />
        <IconButton
          data-testid="av-name-save-btn"
          size="small"
          onClick={onSave}
          disabled={!!validationError}
          color="primary"
          sx={{ mt: '4px' }}
        >
          <CheckIcon fontSize="small" />
        </IconButton>
        <IconButton
          data-testid="av-name-cancel-btn"
          size="small"
          onClick={onCancel}
          sx={{ mt: '4px' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      data-testid="av-name-view"
      display="inline-flex"
      alignItems="center"
      onClick={isEditable ? onStartEdit : undefined}
      sx={
        isEditable
          ? { cursor: 'text', '&:hover [data-testid="av-detail-title-name"]': { opacity: 0.7 } }
          : undefined
      }
    >
      {children}
    </Box>
  );
};
